import { render } from "./AnoneSearchArea.vue?vue&type=template&id=5b97a361"
const script = {}

import "./AnoneSearchArea.vue?vue&type=style&index=0&id=5b97a361&lang=css"

import exportComponent from "/Users/wadayuki/Desktop/anone/anone/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__